import { motion } from "framer-motion";
import { fadeUp } from "../../animations/variants";
import { useEffect } from "react";

const StepSummary = ({ booking, details, onBack, selectedDate }) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <motion.div
      variants={fadeUp}
      initial="hidden"
      animate="show"
      className="text-text"
    >
      {/* LEFT — Summary Card */}
      <div className="border-0 border-border rounded p-6 bg-darkbg shadow-sm">
        <h3 className="text-lg font-semibold mb-6">Review your booking</h3>

        <div className="space-y-4 text-sm">
          <SummaryRow
            label="Date"
            value={
              selectedDate
                ? selectedDate.toLocaleDateString("en-NZ", {
                    day: "2-digit",
                    month: "short",
                    year: "2-digit",
                  })
                : null
            }
          />
          <SummaryRow label="Time" value={booking.time} />
          <SummaryRow label="Service" value={booking.area} />
          <SummaryRow
            label="Guests"
            value={
              booking.persons
                ? `${booking.persons} ${
                    booking.persons === 1 ? "person" : "people"
                  }`
                : null
            }
          />
        </div>
      </div>

      {/* RIGHT — Actions */}
      <div className="block lg:hidden flex flex-col justify-between mt-5">
        <p className="text-xs text-gray-500 leading-relaxed">
          By clicking <strong>Book now</strong>, you confirm that the details
          above are correct and agree to our terms and conditions.
        </p>

        <div className="flex justify-between items-center mt-8">
          <button
            onClick={onBack}
            className="px-8 py-3 rounded-md border border-textGray text-sm hover:bg-border/40 transition text-textGray"
          >
            Back
          </button>

          <button className="px-8 py-3 bg-darkbg text-neonYellow hover:bg-neonYellow hover:text-navy rounded">
            Book now
          </button>
        </div>
      </div>
    </motion.div>
  );
};

/* Small helper for clean alignment */
const SummaryRow = ({ label, value }) => (
  <div className="flex justify-between items-center border-b border-dotted border-textGray pb-2">
    <span className="text-gray-400">{label}</span>
    <span className="font-medium">{value || "—"}</span>
  </div>
);

export default StepSummary;
